module.exports = __webpack_public_path__ + "img/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 3.5cb91584.webp";